import { css } from '@emotion/css';
import { DayLabels, dayLabels } from 'Shared/common/DayLabels';
import { formatDateTime } from 'Shared/common/Macros';
import { theme, settingsExists } from 'Shared/frontend/SettingsProvider';
import { Match, Show, Switch } from 'solid-js';


export function BusinessHoursEntry(P)
{
	/* Note the backend uses its own theme */
	const th = () => settingsExists() ? theme() : { text: {} };

	const headerStyle = () => css(th().text.paragraphTitle);

	const daysList = (days: (keyof DayLabels)[]) => {
		let result = ''
		let sep;
		for (let i=0; i < days.length; i++) {
			if (i == days.length - 1)
				sep = ': ';			//XXX ????
			else if (i == days.length - 2)
				sep = ' and ';
			else
				sep = ', ';

			result += `${dayLabels[days[i]]}${sep}`;
		}
		return result;
	};

	return (
		<Switch>
			<Match when={P.createSectionHeading}>
				<h5 class={headerStyle()}>{P.sectionHeading}</h5>
			</Match>
			<Match when={P.customLabel}>
				<span class={css(th().text.plain)}>{P.customLabel}</span>
			</Match>
			<Match when={true}>
				<span class={css(th().text.plain)}>
					{P.daysopen=='other' ? P.otherDays : daysList(P.daysopen ?? []) }
					<Show when={P.opens} fallback='Closed'> 
						{formatDateTime(P.opens,'h:mma')}
						- {P.closes ? formatDateTime(P.closes,'h:mma') : 'Late'}
					</Show>
				</span>
			</Match>
		</Switch>
	);
}

